import React from "react";
import { Box, Card, Typography, useTheme, IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

export const LabelCard: React.FC<{
  heading: string;
  icon?: React.ReactNode;
  sx?: any;
  headingCenter?: boolean;
  right?: boolean;
  open?: boolean;
  onToggle?: () => void;
}> = (props) => {
  const { heading, icon, headingCenter = false, right = false, open = false, onToggle } = props;
  const theme = useTheme();
  const cardRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
      // Scroll into view with a little offset
      setTimeout(() => {
        if (cardRef.current) {
          const y = cardRef.current.getBoundingClientRect().top + window.scrollY - 40;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <Box
      ref={cardRef}
      sx={{
        mt: 2,
        mb: 1,
        width: "100%",
        backgroundColor: "primary.main",
     borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        cursor: right ? "pointer" : "default",
        [theme.breakpoints.up("md")]: {
          padding: "10px 12px",
         borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        },
        [theme.breakpoints.up("lg")]: {
          padding: "14px 12px",
          borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        },
        [theme.breakpoints.up("xl")]: {
          padding: "16px 12px",
        },
        ...props.sx,
      }}
      onClick={right ? handleToggle : undefined}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent={right ? (headingCenter ? "center" : "space-between") : headingCenter ? "center" : "flex-start"}
      >
        {icon && (
          <Box
            marginRight={1}
            sx={{
              svg: { color: "#fff" },
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          variant="h5"
          color="white"
          fontSize="0.95rem"
          sx={{
            [theme.breakpoints.up("md")]: {
              fontSize: "1.15rem",
            },
            [theme.breakpoints.up("lg")]: {
              fontSize: "0.95rem",
            },
            [theme.breakpoints.up("xl")]: {
              fontSize: "0.95rem",
            },
          }}
        >
          {heading}
        </Typography>
        {right && (
          <IconButton
            size="small"
            sx={{ color: "#fff", ml: 1 }}
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        )}
      </Box>
    </Box>
  );
};


export const TableSellSplit: React.FC<{ heading: string; sx?: any }> = (
  props
) => {
  const { heading } = props;

  return (
    <>
      <Card
        sx={{ padding: "16px", backgroundColor: "primary.main", ...props.sx }}
      >
        <Typography
          variant="h5"
          color={"white"}
          textAlign={"start"}
          fontSize={"0.9rem"}
        >
          {heading}
        </Typography>
      </Card>
    </>
  );
};
